import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../styles/Footer/footer.css";
import instagramIcon from "../Images/instagram.png";
import linkdelnIcon from "../Images/linkedin.png";
import facebookIcon from "../Images/facebook.png";
import twitterIcon from "../Images/twitterx.png";

export default function Footer() {
  return (
    <footer className="footer">
      <Container className="footer-content">
        <div id="showcase-footer">
          {/* Social Icons */}
          <div className="footer-icons">
            <li className="social-icons">
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={twitterIcon} alt="Twitter" />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/company/hrlabss/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkdelnIcon} alt="LinkedIn" />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={facebookIcon} alt="Facebook" />
              </a>
            </li>
            <li className="social-icons-instagram">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={instagramIcon} alt="Instagram" />
              </a>
            </li>
          </div>

          {/* Footer Links */}
          <div className="foot-panel2">
            <div className="branch-section">
              <h1 className="text-lg">Branch</h1>
              <ul className="list-none">
                <li>
                  <h2>Bangalore</h2>
                  <p>+91 99165 55890</p>{" "}
                </li>
                <li>
                  <h2>Madurai</h2>
                  <p>+91 97421 94666</p>{" "}
                </li>
              </ul>
            </div>
            <div className="explore-section">
              <h1 className="text-lg">Explore</h1>
              <ul className="list-none">
                <li>
                  <Link to="/start-here">Start here</Link>
                </li>
                <li>
                  <Link to="/blog">Blog</Link>
                </li>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
              </ul>
            </div>
            <div className="information-section">
              <h1 className="text-lg">Information</h1>
              <ul className="list-none">
                <li>
                  <Link to="/membership">Membership</Link>
                </li>
                <li>
                  <Link to="/purchase-guide">Purchase Guide</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-and-services">Terms and services</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="footer-copywright" style={{ marginTop: "20px" }}>
          <h3>© hrlabs.in | All Rights Reserved</h3>
        </div>
      </Container>
    </footer>
  );
}
